// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2Zl8V","rootSuccess":"CompleteLink_rootSuccess__34VQx","rootFailure":"CompleteLink_rootFailure__QTlkB","isDisabled":"CompleteLink_isDisabled__C632x"};